import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import MemberLogin from "./pages/MemberLogin";
import AdminDashboard from "./pages/AdminDashboard";
import MemberDashboard from "./pages/MemberDashboard";
import MembershipSignup from "./pages/MembershipSignup";
import CorporateMemberships from "./pages/CorporateMemberships";
import AuthCallback from "./pages/AuthCallback";
import AdminSetup from "./pages/AdminSetup";
import AdminLogin from "./pages/AdminLogin";
import CreateAdmin from "./pages/CreateAdmin";
import AdminCreator from "./pages/AdminCreator";
import EnhancedAdminDashboard from "./pages/EnhancedAdminDashboard";
import EnhancedMemberDashboard from "./pages/EnhancedMemberDashboard";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <HashRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          
          {/* Authentication Routes */}
          <Route path="/member-login" element={<MemberLogin />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin-dashboard" element={<EnhancedAdminDashboard />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/admin-setup" element={<AdminSetup />} />
          <Route path="/create-admin" element={<CreateAdmin />} />
          <Route path="/admin-creator" element={<AdminCreator />} />
          
          {/* Member Dashboards */}
          <Route path="/member-dashboard" element={<EnhancedMemberDashboard />} />
          <Route path="/student-portal" element={<EnhancedMemberDashboard />} />
          <Route path="/academic-portal" element={<EnhancedMemberDashboard />} />
          <Route path="/professional-portal" element={<EnhancedMemberDashboard />} />
          <Route path="/chartered-portal" element={<EnhancedMemberDashboard />} />
          <Route path="/training-centre-portal" element={<MemberDashboard />} />
          <Route path="/bronze-portal" element={<MemberDashboard />} />
          <Route path="/silver-portal" element={<MemberDashboard />} />
          <Route path="/gold-portal" element={<MemberDashboard />} />
          
          {/* Membership Signup Routes */}
          <Route path="/join" element={<MembershipSignup />} />
          <Route path="/student-member-signup" element={<MembershipSignup />} />
          <Route path="/academic-member-signup" element={<MembershipSignup />} />
          <Route path="/professional-member-signup" element={<MembershipSignup />} />
          <Route path="/chartered-member-signup" element={<MembershipSignup />} />
          <Route path="/training-centre-signup" element={<MembershipSignup />} />
          <Route path="/corporate-bronze-signup" element={<MembershipSignup />} />
          <Route path="/corporate-silver-signup" element={<MembershipSignup />} />
          <Route path="/corporate-gold-signup" element={<MembershipSignup />} />
          
          {/* Corporate Memberships Overview */}
          <Route path="/corporate-memberships" element={<CorporateMemberships />} />
          
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
